var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTabletArrowLineConference = function SvgTabletArrowLineConference(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83.55,
    height: 16.07,
    viewBox: "0 0 83.55 16.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-111 {\n        fill: #00bc6a;\n      }\n\n      .cls-211 {\n        fill: none;\n        stroke: #00bc6a;\n        stroke-width: 0.92px;\n      }\n\n      .cls-311 {\n        fill: #00c880;\n        stroke: #fff;\n        stroke-width: 2px;\n      }\n\n      .cls-411 {\n        fill: #dff8ed;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M5.65,8.25,0,12.33V4.18Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-211",
    x1: 4.65,
    y1: 8.25,
    x2: 83.55,
    y2: 8.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-311",
    x: 13.68,
    y: 1,
    width: 29.27,
    height: 14.07,
    rx: 3.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-411",
    d: "M21.28,11.37a.31.31,0,0,1-.05.1l-.08.07a.25.25,0,0,1-.11,0h-.11l-1.06-.26a.48.48,0,0,1-.23-.13l-.8-.68a.29.29,0,0,1-.09-.2.25.25,0,0,1,.07-.2A.26.26,0,0,1,19,10a.31.31,0,0,1,.21.06l.79.7,1.06.26a.19.19,0,0,1,.1.05.27.27,0,0,1,.07.08.42.42,0,0,1,0,.1A.41.41,0,0,1,21.28,11.37ZM25.94,8a.56.56,0,0,1-.11.2.7.7,0,0,1-.17.13l-.83.41-.52.62h0L23,10.64a.56.56,0,0,1-.4.17h-.14l-2-.52a.5.5,0,0,1-.21-.1l-1.9-1.48-.86-.39a.62.62,0,0,1-.18-.14A.59.59,0,0,1,17.18,8a.81.81,0,0,1,0-.22.57.57,0,0,1,.07-.22l.86-1.65a.61.61,0,0,1,.33-.28.56.56,0,0,1,.42,0l.79.39,1.69-.5a.53.53,0,0,1,.39,0l1.16.52h.56l.83-.4a.56.56,0,0,1,.42,0,.61.61,0,0,1,.33.28l.86,1.65a.43.43,0,0,1,.06.22.49.49,0,0,1,0,.24ZM23.69,9.2l-1.13-.81-.28.21a1.43,1.43,0,0,1-1.69,0l-.19-.14a.69.69,0,0,1-.16-.18.62.62,0,0,1-.07-.23.67.67,0,0,1,0-.24.63.63,0,0,1,.13-.2l1.38-1.37.06-.06-.29-.11-1.69.5-1,1.83,1.74,1.36,2,.51Zm.65-.73-.95-1.84H22.1L20.71,8l.19.14a.87.87,0,0,0,1,0l.45-.34a.27.27,0,0,1,.17-.06.25.25,0,0,1,.16.06l1.34,1Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTabletArrowLineConference, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TabletArrowLineConference.e0faad1d.svg";
export { ForwardRef as ReactComponent };